import {Component, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {
  Config,
  getConfig, getEditingBusinessUnitEmployee,
  getLookups,
  getSelectedBusinessUnit, getSelectedDealTeamMember,
  initialConfigState,
  initialLookupsState,
  Lookups, toggleLoading
} from "../../../redux";
import {UserCardSize} from "../../../shared/components";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {MatDialog} from "@angular/material/dialog";
import {UtilService} from "../../../shared/services";
import {DealTeamMembersService} from "../../services";

@Component({
  selector: 'app-deal-team-member-info',
  templateUrl: './deal-team-member-info.component.html',
  styleUrls: ['./deal-team-member-info.component.scss']
})
export class DealTeamMemberInfoComponent implements OnInit {

  config$: Subscription = new Subscription();
  lookup$: Subscription = new Subscription();
  selectedBusinessUnit$: Subscription = new Subscription();
  selectedDealTeamMember$: Subscription = new Subscription();
  private config: Config = initialConfigState;
  lookups: Lookups = initialLookupsState;

  selectedDealTeamMember: any = {} as unknown as any;
  userCardSize = UserCardSize;

  //reactive form
  userForm = new FormGroup({
    id: new FormControl(),
    title: new FormControl('', Validators.required),
    isEmployeeActive: new FormControl(false),
  });

  constructor(
    private store: Store,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public util: UtilService,
    private dealTeamMemberService: DealTeamMembersService
  ) {
    this.config$ = this.store.select(getConfig).subscribe(config => {
      this.config = config;
    });
    this.lookup$ = this.store.select(getLookups).subscribe(lookups => {
      this.lookups = lookups;
    });
    this.selectedBusinessUnit$ = this.store.select(getSelectedBusinessUnit).subscribe(selectedBusinessUnit => {

    });

    this.selectedDealTeamMember$ = this.store.select(getSelectedDealTeamMember).subscribe((dtm: any) => {
      this.selectedDealTeamMember = dtm;
      // this.subscribeToDatasource();
    });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.config$.unsubscribe();
    this.lookup$.unsubscribe();
    this.selectedBusinessUnit$.unsubscribe();
    this.selectedDealTeamMember$.unsubscribe();
  }

  subscribeToDatasource() {
    this.getEmployeeInfo();
  }

  getEmployeeInfo() {
    if (!!this.selectedDealTeamMember?.id) {
      this.store.dispatch(toggleLoading({loading: true}));
      this.dealTeamMemberService.getDealTeamMemberById(this.selectedDealTeamMember.id).subscribe({
        next: (res: any) => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.userForm.patchValue(res);
          // this.toastr.success('Employee Loaded', $localize`:@@companyName:Rondeivu`);
        }, error: (err: any) => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.toastr.error("Unable to get employee!", $localize`:@@companyName:Rondeivu`);
        }
      });
    }
  }

  save() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.dealTeamMemberService.saveDealTeamMember(this.selectedDealTeamMember.user.id, this.userForm.getRawValue()).subscribe({
      next: (res: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success('Employee Information Updated', $localize`:@@companyName:Rondeivu`);
      }, error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to update employee!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  back() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(['/' + this.config.selected_business_unit.slug + '/settings/employees/']).then(() => {
      this.store.dispatch(toggleLoading({loading: false}));
    });
  }
}
